import { polygonIoU } from '../../geometry/polygons';
import type { Ring } from '../../geometry/types';

export function shapeupAccuracy(target: Ring, attempt: Ring): number {
  return Math.round(100 * polygonIoU(target, attempt));
}

export function shapeupDelta(accuracy: number): number {
  const bounded = Math.max(0, Math.min(100, accuracy));
  const seconds = bounded >= 90 ? -4 * (bounded - 90) : 90 - bounded;
  return seconds === 0 ? 0 : seconds * 1_000;
}
